export const getTotalRuleCount = (screener: Screener): number => {
  return screener.fields.reduce((total: number, field: ScreenerField) => {
    const answerTagLogic = field.answer_tag_logic || [];
    return (
      total +
      answerTagLogic.filter(
        (rule) =>
          rule.tag_type === 'ideal' ||
          rule.tag_type === 'disqualifying' ||
          rule.tag_type === 'skip_to' ||
          rule.tag_type === 'ignore_disqualified'
      ).length
    );
  }, 0);
};

export type TabType = 'preferences' | 'all_logic';
